import { Component, Input, OnInit } from "@angular/core";
import { faStar as faStarSolid, faStarHalfAlt as faStarSolidHalf, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";

/**
 * This could be used in any other component to display a rating.
 */

@Component({
  selector: 'ush-movie-rating',
  template: `
    <div class="review-rating" *ngIf="rating">
      <i *ngFor="let star of numToArray(rating)" class="pi pi-star-fill" style="font-size: {{size}}rem;"></i>
    </div>
   `,
  styles: `
    .review-rating {
      display: inline!important;
      column-gap: 5px;
      * {
        color: var(--textColor);
      }
    }`
})
export class MovieRatingComponent implements OnInit {
  @Input() rating: number;
  @Input() size: number = 1;


  ngOnInit() {
  }

  numToArray(num: number) {
    return new Array(num);
  }
}

